import React from 'react'

import { Button, FlexBox, Link, useScreenClass } from '@vp/swan'
import UploadFlow from '@vp/upload-flow'

import { useAppContext } from '../../state/AppContext'
import PricingContext from '../../services/serviceClients/PricingContext'
import { isOutOfStock } from './StockOptionUtil'
import PageConfig from '../../utils/pageConfig'
import { trackNavigationClicks } from '../../utils/tracking/tracking'
import { BFFPageData } from '../../services/serviceClients/BffClient'

interface StockOptionCTAProps {
  browseDesign: {
    link: string
  }
  browseDesignCta: string
  uploadDesignCta: string
  productName: string
  productId: string
  mpvId: string
  version: number
  quantities: {
    default: number
  }
  tabIndex: number
  disableUploadFlow: boolean
  pageDataFromBFF: BFFPageData
}

const StockOptionCTA = (props: StockOptionCTAProps) => {
  const isMobile = useScreenClass() === 'xs'
  const { browseDesign, browseDesignCta, uploadDesignCta, productName, productId, mpvId, version, quantities, tabIndex, disableUploadFlow, pageDataFromBFF } =
    props

  const { merchandisingCategoryId, locale, vatInclusivity } = useAppContext()

  return (
    <FlexBox flexWrap={isMobile ? 'wrap' : 'unset'} gap="between-actions" flexDirection="row" marginTop={6}>
      <Button
        skin={isOutOfStock(mpvId, pageDataFromBFF) ? null : 'primary'}
        width="full-width"
        render={(props) => (
          <Link
            to={browseDesign.link}
            className={props.className}
            aria-disabled={isOutOfStock(mpvId, pageDataFromBFF)}
            onClick={() => {
              trackNavigationClicks({
                categoryId: merchandisingCategoryId,
                pageZone: 'stockOptions',
                destinationUrl: browseDesign.link,
                tabIndex: tabIndex + 1,
                stockOptionsCtaText: 'Browse Designs',
              })
            }}
          >
            {props.children}
          </Link>
        )}
      >
        {browseDesignCta}
      </Button>

      {!disableUploadFlow && (
        <UploadFlow
          vatInc={vatInclusivity}
          analyticsPageData={{
            pageSection: 'Category Page',
            pageStage: 'Discover',
            pageName: `${merchandisingCategoryId}:Category Page`,
            productName,
            coreProductId: productId,
            // @ts-expect-error Label is needed but missing in type definition
            label: `Options Display:stockOptions:${tabIndex + 1}`,
          }}
          tenant={PageConfig.tenant}
          locale={locale}
          pricingContextString={PricingContext.getPricingContext()}
          mpvId={mpvId}
          loader={
            <Button skin="secondary" width="full-width" disabled>
              {uploadDesignCta}
            </Button>
          }
          productKey={productId}
          productName={productName}
          productVersion={version}
          quantity={quantities?.default}
          requestor={PageConfig.requestor}
        >
          <Button skin="secondary" width="full-width" disabled={isOutOfStock(mpvId, pageDataFromBFF)}>
            {uploadDesignCta}
          </Button>
        </UploadFlow>
      )}
    </FlexBox>
  )
}

export default StockOptionCTA
